import React from 'react';

import i18n from '../../i18n';

// @mui
import { TextField, MenuItem } from '@mui/material';

/**
 * Picks an API controller (`roles`, `payin-instances`…), as a role permission
 * is keyed by one. The list is the controllers the signed-in user's metadata
 * names — the same one the grid's controller filter offers — so a permission
 * can only be created for a controller that exists.
 */
export default class DialogControllerSelectField extends React.Component {
    controllers() {
        const { controllersData } = this.props.context?.getState?.() || {};
        const label = (controller) =>
            i18n.t(`controllers.${controller}`, { defaultValue: controller });
        return [...(controllersData?.controllers || [])].sort((a, b) =>
            label(a).localeCompare(label(b))
        );
    }

    render() {
        const { field, value, disabled, error, onBlur, autoFocus } = this.props;
        return (
            <TextField
                select
                fullWidth
                id={field.id}
                name={field.id}
                label={i18n.t(`columns.${field.label}`)}
                value={value || ''}
                disabled={Boolean(disabled || field.onlyRead)}
                required={field.required}
                error={Boolean(error)}
                helperText={error}
                onBlur={onBlur}
                autoFocus={autoFocus}
                onChange={(event) =>
                    this.props.onChange(field.id, event.target.value)
                }
            >
                {this.controllers().map((controller) => (
                    <MenuItem key={controller} value={controller}>
                        {i18n.t(`controllers.${controller}`, {
                            defaultValue: controller
                        })}
                    </MenuItem>
                ))}
            </TextField>
        );
    }
}
